import { css } from '@emotion/react';

import { media } from '../shared/styles';

export const rootStyles = css`
  display: flex;
  flex-direction: column-reverse;
  gap: var(--spacing-3);
  width: 100%;

  ${media.md} {
    flex-direction: row;
    align-items: stretch;
  }
`;

export const textPanelStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
  background-color: var(--surface-subtle);
  border: 1px solid var(--color-brown-100);
  border-radius: var(--radius-lg);
  padding: var(--spacing-7) var(--spacing-5);

  ${media.md} {
    padding: var(--spacing-14) var(--spacing-8);
  }
`;

export const textContentStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-6);
  align-items: flex-start;
`;

export const copyStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  color: var(--text-primary);
`;

export const titleStyles = css`
  && {
    font-size: 24px;
    line-height: 28px;

    ${media.md} {
      font-size: 32px;
      line-height: 40px;
    }
  }
`;

export const descriptionStyles = css`
  && {
    font-size: 14px;
    line-height: 20px;

    ${media.md} {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

export const imageGridStyles = css`
  display: grid;
  flex: 1;
  min-width: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: var(--spacing-3);
  overflow: hidden;

  ${media.md} {
    align-self: stretch;
  }
`;

export const imageCellStyles = css`
  position: relative;
  border-radius: var(--radius-lg);
  overflow: hidden;
  min-height: 120px;
  aspect-ratio: 1 / 1;

  ${media.md} {
    min-height: 0;
    aspect-ratio: auto;
  }

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: var(--radius-lg);
  }
`;
